// eslint-disable-next-line import/prefer-default-export
export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';
